/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1IndividualpaymentParcelsParcelidQueryResponse,
  GetApiV1IndividualpaymentParcelsParcelidPathParams,
  GetApiV1IndividualpaymentParcelsParcelidQueryParams,
  GetApiV1IndividualpaymentParcelsParcelid400,
  GetApiV1IndividualpaymentParcelsParcelid401,
  GetApiV1IndividualpaymentParcelsParcelid404,
  GetApiV1IndividualpaymentParcelsParcelid500,
} from "../../types/individualPaymentParcelsController/GetApiV1IndividualpaymentParcelsParcelid.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1IndividualpaymentParcelsParcelid } from "../../clients/individualPaymentParcelsController/getApiV1IndividualpaymentParcelsParcelid.ts";

export const getApiV1IndividualpaymentParcelsParcelidQueryKey = (
  parcelId: GetApiV1IndividualpaymentParcelsParcelidPathParams["parcelId"],
  params?: GetApiV1IndividualpaymentParcelsParcelidQueryParams,
) =>
  [
    {
      url: "/api/v1/individualpayment/parcels/:parcelId",
      params: { parcelId: parcelId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1IndividualpaymentParcelsParcelidQueryKey = ReturnType<
  typeof getApiV1IndividualpaymentParcelsParcelidQueryKey
>;

export function getApiV1IndividualpaymentParcelsParcelidQueryOptions(
  parcelId: GetApiV1IndividualpaymentParcelsParcelidPathParams["parcelId"],
  params?: GetApiV1IndividualpaymentParcelsParcelidQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1IndividualpaymentParcelsParcelidQueryKey(
    parcelId,
    params,
  );
  return queryOptions<
    GetApiV1IndividualpaymentParcelsParcelidQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentParcelsParcelid400
      | GetApiV1IndividualpaymentParcelsParcelid401
      | GetApiV1IndividualpaymentParcelsParcelid404
      | GetApiV1IndividualpaymentParcelsParcelid500
    >,
    GetApiV1IndividualpaymentParcelsParcelidQueryResponse,
    typeof queryKey
  >({
    enabled: !!parcelId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1IndividualpaymentParcelsParcelid(parcelId, params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Devolve a parcela com exatamente os campos que o PUT parcels/{parcelId} aceita, mais os textos traduzidos ('typeText', 'statusText', 'paymentMethodText'), o contexto somente leitura (pagamento, estorno, prorrogação, datas de integração bancária e eNotas) e a auditoria ('userCreation', 'creationDate', 'userLastChange', 'lastChangeDate'). Use este endpoint para carregar o formulário: o PUT é full-replace e 'fine', 'totalDiscount', 'retroactiveDiscount', 'message', 'invoiceIssueDate' e 'fractionOfParcel' não são devolvidos pela grid de parcelas. 404 quando a parcela não existe. Sem equivalente no legado (o GET IndividualPayment/EditParcel apenas renderizava a view). **(Requer Authorization para autenticação)**
 * @summary Retorna uma parcela no formato aceito pela edição (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/parcels/:parcelId}
 */
export function useGetApiV1IndividualpaymentParcelsParcelid<
  TData = GetApiV1IndividualpaymentParcelsParcelidQueryResponse,
  TQueryData = GetApiV1IndividualpaymentParcelsParcelidQueryResponse,
  TQueryKey extends QueryKey = GetApiV1IndividualpaymentParcelsParcelidQueryKey,
>(
  parcelId: GetApiV1IndividualpaymentParcelsParcelidPathParams["parcelId"],
  params?: GetApiV1IndividualpaymentParcelsParcelidQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1IndividualpaymentParcelsParcelidQueryResponse,
        ResponseErrorConfig<
          | GetApiV1IndividualpaymentParcelsParcelid400
          | GetApiV1IndividualpaymentParcelsParcelid401
          | GetApiV1IndividualpaymentParcelsParcelid404
          | GetApiV1IndividualpaymentParcelsParcelid500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1IndividualpaymentParcelsParcelidQueryKey(parcelId, params);

  const query = useQuery(
    {
      ...getApiV1IndividualpaymentParcelsParcelidQueryOptions(
        parcelId,
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentParcelsParcelid400
      | GetApiV1IndividualpaymentParcelsParcelid401
      | GetApiV1IndividualpaymentParcelsParcelid404
      | GetApiV1IndividualpaymentParcelsParcelid500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
